import { render, staticRenderFns } from "./tambahinsidetalk.vue?vue&type=template&id=b7e71646&"
import script from "./tambahinsidetalk.vue?vue&type=script&lang=js&"
export * from "./tambahinsidetalk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports